
import React from "react";
import Step2NumberSelectExisting from "../Step2NumberSelectExisting";
import Step2NumberBuyNew from "../Step2NumberBuyNew";

interface Step2NumberContentProps {
  showSelectExisting: boolean;
  existingNumbers: any[];
  selectedNumberId: string;
  setSelectedNumberId: (id: string) => void;
  error: string | null;
  onPrev: () => void;
  handleNumberSelect: () => void;
  loading: boolean;
  showBuyNew: boolean;
  setShowBuyNew: (show: boolean) => void;
  areaCode: string;
  setAreaCode: (code: string) => void;
  handleBuy: (e: React.FormEvent) => void;
  setError: (error: string | null) => void;
}

/**
 * Component that renders either the "select existing" or "buy new" number view
 */
const Step2NumberContent = ({
  showSelectExisting,
  existingNumbers,
  selectedNumberId,
  setSelectedNumberId,
  error,
  onPrev,
  handleNumberSelect,
  loading,
  showBuyNew,
  setShowBuyNew,
  areaCode,
  setAreaCode,
  handleBuy,
  setError,
}: Step2NumberContentProps) => {
  return (
    <>
      {showSelectExisting && (
        <Step2NumberSelectExisting
          existingNumbers={existingNumbers}
          selectedNumberId={selectedNumberId}
          setSelectedNumberId={setSelectedNumberId}
          error={error}
          onPrev={onPrev}
          onNext={handleNumberSelect}
          loading={loading}
          setShowBuyNew={setShowBuyNew}
          setError={setError}
        />
      )}
      {(!showSelectExisting || showBuyNew) && (
        <Step2NumberBuyNew
          areaCode={areaCode}
          setAreaCode={setAreaCode}
          error={error}
          onPrev={onPrev}
          onSubmit={handleBuy}
          loading={loading}
          existingNumbersCount={existingNumbers.length}
          setShowBuyNew={setShowBuyNew}
          setError={setError}
        />
      )}
    </>
  );
};

export default Step2NumberContent;

